import {DoCheck, Injectable} from '@angular/core';
import {FormasPagamentoLoja} from './formas-pagamento-loja';
import {PedidoLoja} from '../../objeto/PedidoLoja';
import {Pagamento} from '../../objeto/Pagamento';
import {FormaDePagamento} from '../../objeto/FormaDePagamento';

interface OfertaPagamentoDesktop {
  total: number;
  desconto: number;
  economia: number;
  taxa: number;
  melhorOferta: boolean;
}

@Injectable()
export class FormasPagamentoLojaDesktop extends FormasPagamentoLoja implements DoCheck {
  ofertasPagamentoDesktop: {[id: number]: OfertaPagamentoDesktop} = {};

  ngDoCheck(): void {
    this.ofertasPagamentoDesktop = {};
    if(!this.pedido?.itens?.length || typeof this.pedido.calculeTotal !== 'function') return;

    const formas = [...this.formasDePagamento, ...this.formasDePagamentoOnline,
      ...this.formasDePagamentoPix, ...this.formasDePagamentoManual, this.formaPagamentoCarteirasDigitais];
    const habilitadas = [...new Map<number, FormaDePagamento>(formas.filter(forma => forma && this.estaHabilitado(forma, this.pedido))
      .map(forma => [forma.id, forma] as [number, FormaDePagamento])).values()];
    if(!habilitadas.length) return;
    const totalSemForma = this.simulePagamentoDesktop(null).total;
    for(const forma of habilitadas) {
      const simulacao = this.simulePagamentoDesktop(forma);
      this.ofertasPagamentoDesktop[forma.id] = {...simulacao,
        economia: Math.max(0, Number((totalSemForma - simulacao.total).toFixed(2))), melhorOferta: false};
    }

    const ordenadas = Object.values(this.ofertasPagamentoDesktop).sort((a, b) => a.total - b.total);
    if(ordenadas.length > 1 && ordenadas[0].total < ordenadas[1].total &&
      ordenadas[0].desconto > 0 && ordenadas[0].economia > 0) ordenadas[0].melhorOferta = true;
  }

  private simulePagamentoDesktop(forma: FormaDePagamento) {
    // O cálculo altera itens e cupom. Copiar os objetos preserva o carrinho e o pagamento selecionado.
    const simulacao = Object.assign(new PedidoLoja(), this.pedido);
    simulacao.itens = this.pedido.itens.map(item => Object.assign(Object.create(Object.getPrototypeOf(item)), item));
    simulacao.cupom = this.pedido.cupom ? {...this.pedido.cupom} : null;
    simulacao.pagamento = Object.assign(new Pagamento(), this.pagamento, {formaDePagamento: forma});
    if(this.cashback?.usar) simulacao.cashback = {...this.cashback};
    if(forma?.modoDesconto === 'PRODUTOS' && !this.exibeDesconto(forma))
      simulacao.pagamento.formaDePagamento = Object.assign({}, forma, {possuiDesconto: false});
    simulacao.calculeTotal();
    return {total: Math.max(0, simulacao.obtenhaValorAhPagar()),
      desconto: Number(simulacao.descontoFormaDePagamento || 0), taxa: Number(simulacao.taxaFormaDePagamento || 0)};
  }

  nomePagamentoDesktop(forma: FormaDePagamento): string {
    if(forma.online && this.pagamentoOnlineEstaSelecionado(forma) && this.pagamento.dadosCartao?.descricaoPagamento)
      return this.pagamento.dadosCartao.descricaoPagamento;
    return forma.online ? this.descricaoFormaPagamentoOnline(forma) : forma.descricao;
  }

  iconePagamentoDesktop(forma: FormaDePagamento): string {
    if(forma.nome === 'dinheiro') return 'fa-money-bill-wave';
    if(forma.pix || forma.formaDePagamentoPdv?.metodo === 'PIX' || forma.nome?.includes('pix')) return 'fa-qrcode';
    return 'fa-credit-card';
  }

  descricaoPagamentoDesktop(forma: FormaDePagamento): string {
    if(this.ofertasPagamentoDesktop[forma.id]?.desconto > 0 && this.exibeDesconto(forma))
      return forma.modoDesconto === 'PRODUTOS' ? 'Desconto em produtos selecionados.' : `${forma.desconto}% de desconto.`;
    if(forma.formaDePagamentoPdv?.tipo === 'MANUAL') return 'Pague por Pix após confirmar o pedido.';
    return '';
  }
}
